// extracted by mini-css-extract-plugin
export default {"container":"Day--container--vUt4o","day":"Day--day--R1A4B","today":"Day--today--4ut15","icon":"Day--icon--j6x6G","active":"Day--active--qDNHN","triangle":"Day--triangle--F4ppa"};